<div class="mod-approval-threshold page-container" *ngIf="canView()">
  <p-toast />
  <div class="page-header">
    <h2>{{ 'modification_approval_threshold.title' | translate }}</h2>
    <p class="subtitle">
      {{ 'modification_approval_threshold.subtitle' | translate }}
    </p>
  </div>

  <div class="form-card" [class.loading]="loading()">
    <div class="field">
      <label for="increaseL3Percent">
        {{
          'modification_approval_threshold.fields.increase_l3_percent'
            | translate
        }}
      </label>
      <p-inputNumber
        inputId="increaseL3Percent"
        [ngModel]="increaseL3Percent()"
        (ngModelChange)="increaseL3Percent.set($event)"
        [min]="1"
        [max]="100"
        suffix=" %"
        [disabled]="!canEdit() || loading() || saving()"
        [showButtons]="true"
      />
    </div>

    <div class="field">
      <label for="decreaseL3Percent">
        {{
          'modification_approval_threshold.fields.decrease_l3_percent'
            | translate
        }}
      </label>
      <p-inputNumber
        inputId="decreaseL3Percent"
        [ngModel]="decreaseL3Percent()"
        (ngModelChange)="decreaseL3Percent.set($event)"
        [min]="1"
        [max]="100"
        suffix=" %"
        [disabled]="!canEdit() || loading() || saving()"
        [showButtons]="true"
      />
    </div>

    <div class="field">
      <label for="highValueItemAmount">
        {{
          'modification_approval_threshold.fields.high_value_item_amount'
            | translate
        }}
      </label>
      <p-inputNumber
        inputId="highValueItemAmount"
        [ngModel]="highValueItemAmount()"
        (ngModelChange)="highValueItemAmount.set($event)"
        [min]="0"
        mode="currency"
        currency="VND"
        locale="vi-VN"
        [disabled]="!canEdit() || loading() || saving()"
      />
    </div>

    <div class="field row">
      <label for="enabled">
        {{ 'modification_approval_threshold.fields.enabled' | translate }}
      </label>
      <p-toggleswitch
        inputId="enabled"
        [ngModel]="enabled()"
        (ngModelChange)="enabled.set($event)"
        [disabled]="!canEdit() || loading() || saving()"
      />
    </div>

    <div class="actions" *ngIf="canEdit()">
      <app-button
        [label]="'common.actions.save' | translate"
        severity="info"
        [loading]="saving()"
        [disabled]="loading()"
        (emitOnClick)="save()"
      />
    </div>
  </div>
</div>
